<template>
  <div>
    <v-btn
      color="primary"
      dark
      small
      @click="load"
    >
      Progreso
    </v-btn>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ student.name }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items />
        </v-toolbar>
        <v-container>
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
            >
              <v-container
                class="fill-height"
                fluid
              >
                <v-row
                  align="center"
                  justify="space-around"
                >
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>Última conexión: {{ lastSignInTime }}</v-list-item-title>
                        <v-list-item-subtitle>
                          Estudiante: {{ student.name }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-progress-linear
                      :model="countLevels"
                      :value="countLevels*12.50"
                      height="20"
                    >
                      <strong>{{ (countLevels*12.50).toFixed(2) }}%</strong>
                    </v-progress-linear>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    Episodio {{ episode_id }}
                    <v-select
                      v-model="report_option"
                      label="Seleccione evaluación"
                      :items="options"
                      item-text="label"
                      outlined
                    />
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <span>Promedio de respuestas correctas por nivel: <strong>{{ average }}</strong></span>
                          <span>Promedio de tiempo de respuesta por multiplicación (mm:ss): <strong>{{ acumSolveTime }}</strong></span>
                          <span>Promedio de tiempo de lectura por cuadro de texto (mm:ss): <strong>{{ acumStoryTime }}</strong></span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider />
              <v-container
                class="fill-height"
                fluid
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col
                    cols="12"
                    lg="7"
                  >
                    <v-item-group multiple>
                      <v-container
                        class="fill-height"
                      >
                        <v-row
                          align="center"
                          justify="center"
                        >
                          <v-col
                            v-for="(level, index) in levels"
                            :key="index"
                            cols="6"
                            sm="4"
                            md="3"
                            class="justify-center"
                          >
                            <v-hover v-slot:default="{ hover }">
                              <v-card
                                max-width="150"
                              >
                                <v-toolbar
                                  dark
                                  color="primary"
                                >
                                  <v-toolbar-title>Nivel {{ index + 1 }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-title class="headline text-center mb-5 font-weight-bold">
                                  {{ level.total_correct }}/{{ level.total_answered }}
                                </v-card-title>

                                <v-card-actions class="justify-center">
                                  <v-icon large>
                                    {{ level.locked ? 'mdi-lock' : 'mdi-lock-open-variant' }}
                                  </v-icon>
                                </v-card-actions>
                                <v-fade-transition>
                                  <v-overlay
                                    v-show="hover"
                                    absolute
                                    color="#036358"
                                  >
                                    <v-btn
                                      large
                                      text
                                      block
                                      @click="lockLevel(index)"
                                    >
                                      {{ level.locked ? 'Desbloquear' : 'Bloquear' }}
                                    </v-btn>
                                    <dialog-lists-exercise
                                      :item="index"
                                    />
                                    <dialog-lists-report-student
                                      :item="index"
                                      :level="level"
                                      :type-user="typeUser"
                                      :student="listsStudent"
                                    />
                                  </v-overlay>
                                </v-fade-transition>
                              </v-card>
                            </v-hover>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-item-group>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="5"
                  >
                    <chart-line-student
                      :levels="chartLevels"
                      title="Respuestas correctas por nivel"
                      option="total_correct"
                    />
                    <chart-line-student
                      :levels="chartLevels"
                      title="Promedio de tiempo de respuesta por multiplicación"
                      option="solve_time"
                      text="Seg."
                    />
                    <chart-line-student
                      :levels="chartLevels"
                      title="Promedio de tiempo de lectura por cuadro de texto"
                      option="story_time"
                      text="Seg."
                    />
                  </v-col>
                </v-row>
              </v-container>
              <help-button
                :tutorial="tutorial"
              />
            </v-col>
          </v-row>
        </v-container>
        
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import axios from 'axios'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'
  import DialogListsExercise from '@/views/dashboard/pages/panel/DialogListsExercise'
  import ChartLineStudent from '@/views/dashboard/pages/panel/ChartLineStudent'
  import DialogListsReportStudent from '@/views/dashboard/pages/panel/DialogListsReportStudent'

  export default {
    components: {
      HelpButton,
      DialogListsExercise,
      ChartLineStudent,
      DialogListsReportStudent,
    },
    props: {
      id: {
        type: String,
        default: '',
      },
      typeStudent: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        items: [],
        // tutorial: 'player-progress-students',
        name: '',
        nickname: '',
        episode_id: 1,
        uid: '',
        history: {},
        documents: {},
        levels: [],
        options: [
          { value: 0, label: 'Evaluación #1' },
          { value: 1, label: 'Evaluación #2' },
        ],
        report_option: 0,
        levels_history: [],
        average: 0,
        acumSolveTime: 0,
        acumStoryTime: 0,
        textCount: 0,
        countLevels: 0,
        totalCorrect: 0,
        currentLevelQuizzes: [],
        levelsData: [],
        levelsLabel: [],
        lastSignInTime: null,
        lastSignInTimeUrl:
          'https://us-central1-videojuego-sh.cloudfunctions.net/lastSignInTime',
        overlay: false,
        dialog: false,
        student: '',
        countLevelsNotCompleted: 0,
        typeUser: ''
      }
    },
    computed: {
      ...mapState(['user', 'userData']),
      chartLevels () {
        return this.levels
      },
      // typeUser () {
      //   return this.userData.type
      // },
      listsIndex () {
        return this.index
      },
      listsStudent () {
        return this.student
      },
      tutorial()
      {
        //return 'player-progress-students';
        console.log(this.typeUser);
        return this.typeUser === 'student' ? 'player-progress-students' : 'tutor-demo-progress'
      }
    },
    watch: {
      report_option (value) {
        this.selectReport(value)
      },
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.$store.commit('SET_LOADING', true)
        this.uid = this.id
        this.getUser(this.uid)
        this.getLastSignInTime(this.uid)
      },
      getLastSignInTime (uid) {
        axios
          .post(this.lastSignInTimeUrl, {
            uid: uid,
          })
          .then((response) => {
            const data = response.data
            const error = data.error
            if (!error) {
              // const message = data.message
              this.lastSignInTime = data.lastSignInTime
            } else {
              this.$store.commit('SET_LOADING', false)
            }
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            console.log(error)
            alert(error)
          })
      },
      getUser (uid) {
        firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .get()
          .then((response) => {
            const data = response.data()
            this.name = `${data.firstname} ${data.lastname}`
            this.nickname = data.nickname
            this.history = data.history
            this.levels_history = this.history.episode_1.levels
            this.typeUser = data.type
            this.setData()
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false)
            console.log(error)
            alert(error)
          })
      },
      setData () {
        this.getQuizzes()
      },
      getQuizzes () {
        var quizzes = {}
        firebase
          .firestore()
          .collection('quiz')
          .where('user_id', '==', this.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((document) => {
              const data = document.data()
              const levelId = data.level_id
              if (quizzes[levelId] == null) {
                quizzes[levelId] = []
              }
              quizzes[levelId].push(document)
            })
          })
          .then(() => {
            this.documents = {}
            for (var i = 0; i < 8; i++) {
              var levelId = `010${i + 1}`
              if (quizzes[levelId] != null) {
                // console.log(quizzes[levelId], levelId)
                this.getInformation(quizzes[levelId], levelId)
              }
            }
          })
          .then(() => {
            this.selectReport(0)
          })
      },
      getInformation (docsData, levelId) {
        const docs = []

        for (var i = 0; i < docsData.length; i++) {
          var document = docsData[i]
          const data = document.data()
          const endTime = data.end_time
          if (endTime != null) {
            docs.push(document)
          }
        }

        docs.sort(
          (a, b) =>
            new Date(a.data().end_time.toDate()).getTime() -
            new Date(b.data().end_time.toDate()).getTime(),
        )

        this.documents[levelId] = docs.slice(0, 2)
      },
      selectReport (index) {
        this.levels = []
        this.levelsLabel = []
        this.levelsData = []

        this.countLevels = 0
        this.average = 0
        this.acumSolveTime = 0
        this.totalCorrect = 0

        let avgLevelTimeMultiplication = 0
        let avgTotalTimeMultiplication = 0

        let avgLevelStoryTime = 0
        let avgTotalStoryTime = 0

        for (var i = 0; i < 8; i++) 
        {
          var levelId = `010${i + 1}`
          var locked = this.levels_history[i].locked

          var level = {}
          if (this.documents[levelId] != null) 
          {
            if (
              this.documents[levelId].length > 0 &&
              this.documents[levelId][index] != null
            ) {
              var document = this.documents[levelId][index]
              var data = document.data()
              var playTimeDate = new Date(null)
              playTimeDate.setSeconds(data.play_time)
              const playTime = playTimeDate.toISOString().substr(11, 8)
              const answers = String(data.answers)
              const totalCorrect = answers.split('2').length - 1
              const totalAnswered = 20 - (answers.split('0').length - 1)
              const endTime = data.end_time ? data.end_time.toDate() : null
              this.totalCorrect += totalCorrect

              avgLevelTimeMultiplication = data.solve_time / totalAnswered
              avgTotalTimeMultiplication += avgLevelTimeMultiplication

              avgLevelStoryTime = data.story_time / data.text_count
              avgTotalStoryTime += avgLevelStoryTime
              if (totalAnswered === 20) 
              {
                this.countLevels += 1
              }
              this.countLevelsNotCompleted += 1

              level = {
                quiz_id : this.documents[levelId][index].id,
                locked,
                total_correct: totalCorrect,
                total_answered: totalAnswered,
                end_time: endTime,
                level_id: data.level_id,
                avgLevelTimeMultiplication,
                avgLevelStoryTime,
                solve_time: data.solve_time,
                story_time: data.story_time,
                text_count: data.text_count,
                answers,
                play_time: playTime,

              }
            } 
            else //no quiz found
            {
              level = {
                quiz_id: null,
                locked,
                total_correct: 0,
                total_answered: 0,
                endTime: null,
                level_id: null,
                avgLevelTimeMultiplication: 0,
                avgTotalStoryTime: 0,
                solve_time: 0,
                story_time: 0,
                text_count: 0,
                answers: '00000000000000000000',
                play_time: '00:00:00',
              }
            }
          } 
          else 
          {
            level = {
              quiz_id: null,
              locked,
              total_correct: 0,
              total_answered: 0,
              endTime: null,
              level_id: null,
              avgLevelTimeMultiplication: 0,
              avgTotalStoryTime: 0,
              solve_time: 0,
              story_time: 0,
              text_count: 0,
              answers: '00000000000000000000',
              play_time: '00:00:00',
            }
          }

          this.levels.countLevels = this.countLevels

          this.levels.push(level)

        }//for end

          if(this.countLevels > 0)
          {
            this.levels.average = this.totalCorrect / this.countLevels
            this.levels.avgTotalTimeMultiplication = (avgTotalTimeMultiplication / this.countLevels)
            this.levels.avgTotalStoryTime = (avgTotalStoryTime / this.countLevels)

            // this.levels.avgTotalTimeMultiplication = Math.ceil(this.levels.avgTotalTimeMultiplication);
            // this.levels.avgTotalStoryTime = Math.ceil(this.levels.avgTotalStoryTime);

          }
          else
          {
            this.levels.average = 0
            this.levels.avgTotalTimeMultiplication = 0
            this.levels.avgTotalStoryTime = 0
          }

          this.average = this.levels.average
          this.acumSolveTime = this.formatSeconds(this.levels.avgTotalTimeMultiplication)
          this.acumStoryTime = this.formatSeconds(this.levels.avgTotalStoryTime)
          this.average = this.average.toFixed(2)

        this.$store.commit('SET_LOADING', false)
      },
      formatSeconds (seconds) {
        return moment()
          .hours(0)
          .minutes(0)
          .seconds(Math.round(seconds))
          .format('mm:ss')
      },
      toSeconds (timer) {
        return moment.duration(timer).as('seconds')
      },
      lockLevel (index) {
        if (this.typeStudent === 'assingned') {
          if (!this.student.tutor_extra_permission.blockLevels) {
            alert('Operación no autorizada')
            return
          }
        }
        const level = this.levels_history[index]
        level.locked = !level.locked
        this.levels[index].locked = level.locked
        const levelsToServer = JSON.parse(JSON.stringify(this.levels_history))
        levelsToServer.forEach((_) => {
          delete _.color
        })
        this.updateLockedLevels(levelsToServer, this.uid, index)
      },
      updateLockedLevels (levelsToServer, uid, index) {
        firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .update({
            history: {
              episode_1: {
                levels: levelsToServer,
              },
            },
          })
          .then(() => {
            console.log(
              `Se actualizó correctamente bloqueo del nivel ${index + 1}.`,
            )
          // alert(`Se actualizó correctamente bloqueo del nivel ${index + 1}.`);
          })
          .catch((error) => {
            console.log(error)
            alert(`Error al actualizar el bloqueo del nivel ${index + 1}.`)
          })
      },
      async load () {
        const student = await this.$store.dispatch('GET_STUDENT', this.id)
        this.student = student
        this.dialog = true
      },
    },
  }
</script>
